import vinayakImg from "../../assets/images/instructors/vinayak.jpg";
import madhuImg from "../../assets/images/instructors/madhu.jpg";
import guestImg from "../../assets/images/instructors/guest.jpg";

export const INSTRUCTOR_DATA = [
  {
    id: 2,
    image: madhuImg,
    name: "Madhunandan P Rao",
    designation: "Founder and Instructor",
    bio: "Passionate about mentoring UPSC aspirants, Madhunandan specializes in breaking down complex topics into easy-to-understand concepts. His expertise in Economics and Polity, combined with his focus on analytical thinking and answer writing, has helped numerous students.",
    phone: "+91-9008991032",
    email: "contact@iasjnani.com",
    qualification: "B.E, M.Tech, M.B.A, P.G.D.L.G, (M.Sc)",
  },
  {
    id: 1,
    image: vinayakImg,
    name: "Vinayak Petlae",
    designation: "Founder and Instructor",
    bio: "An educator on a mission to simplify UPSC preparation, Vinayak brings expertise in guiding aspirants through strategic mentorship and innovative teaching methods. His structured approach to History and Geography ensures conceptual clarity and exam-oriented preparation.",
    phone: "+91-7353999994",
    email: "contact@iasjnani.com",
    qualification: "B.E, M.S, M.B.A, M.A, P.G.D.E.M, P.G.D.J",
  },

  {
    id: 3,
    image: guestImg,
    name: "Guest Lecturer",
    designation: "Instructor",
    bio: "A distinguished expert in their domain, our guest lecturers provide unique insights and exam-relevant strategies. With their extensive experience, they help aspirants develop a deeper understanding of critical subjects.",
    phone: "+91-9008991032",
    email: "contact@iasjnani.com",
  },
];
